<div class="fw-SecondaryNavigation clearfix" *ngIf="showSecondNav">
  <ul class="fw-SecondaryNavigation_List">
    <ng-container *ngFor="let secondLevel of secondNavLinks; let i = index">
        <li [class.active]="selectedPageId == secondLevel.id">
          <a id="nav-{{secondLevel.id}}" href="javascript:void(0);" #navLink
             (click)="handleChildNavigation(secondLevel)"
             class="" [attr.aria-current]="selectedPageId == secondLevel.id ? 'page': 'false'"
             (keydown)="handleKeyDown($event, i)">
            <span class="navbar-childmenu"> {{ secondLevel.name | pershingTranslate}} </span>
          </a>
        </li>
    </ng-container>
  </ul>
</div>